import { View, Text, Image, TouchableOpacity } from "react-native";
import React from "react";
import QA from "../../assets/svg/QA";
import translate from "../../functions/translate";
import { supportIcon } from "../../imports";
import MyText from "../custom/MyText";
import { white } from "../../colors";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { Toast } from "react-native-toast-message/lib/src/Toast";

export default function UserHelper() {
  const navigation = useNavigation();
  const main = useSelector((store) => store.main);
  return (
    <View style={{ width: "94%", flexDirection: "row", marginVertical: 15 }}>
      <TouchableOpacity
        onPress={() => navigation.navigate("CommonQuestions")}
        style={{
          flex: 1,
          height: 150,
          backgroundColor: "#ab3838",
          borderRadius: 10,
          padding: 10,
          alignItems: "center",
        }}
      >
        <MyText
          style={{
            textAlign: "center",
            fontSize: 22,
            color: white,
          }}
        >
          {translate("common questions")}
        </MyText>
        <View style={{ flex: 1 }}></View>
        <View style={{ alignItems: "flex-end", width: "100%" }}>
          <QA />
        </View>
      </TouchableOpacity>
      <View style={{ width: 15 }}></View>
      <TouchableOpacity
        onPress={() => {
          main.token === null
            ? Toast.show({
                type: "error",
                text1: translate("please login first"),
              })
            : navigation.navigate("Support");
        }}
        style={{
          flex: 1,
          height: 150,
          backgroundColor: "#feb94e",
          borderRadius: 10,
          padding: 10,
          paddingBottom: 0,
          alignItems: "center",
        }}
      >
        <MyText
          style={{
            textAlign: "center",
            fontSize: 22,
            color: white,
          }}
        >
          {translate("online support")}
        </MyText>
        <View style={{ flex: 1 }}></View>
        <View style={{ alignItems: "flex-end", width: "100%" }}>
          <Image
            source={supportIcon}
            style={{ height: 80, width: 80 }}
            resizeMode="contain"
          />
        </View>
      </TouchableOpacity>
    </View>
  );
}
